/**
 * Julie Josephine – mobile menu (consumer view), search in place.
 *
 * The <predictive-search> element in header-jj-mobile-menu-v2.liquid does the
 * fetching and the rendering on its own; all this has to do is say when
 * results are showing, so the categories and the small links get out of the
 * way and come back when the field is emptied. Also clears the field when the
 * menu closes, so reopening it shows the categories rather than an old search.
 */
(function () {
  'use strict';

  function bindInPlaceSearch() {
    var input = document.querySelector('[data-jj-mmb-search]');
    if (!input) return;
    var menu = input.closest('.jj-mmb');
    var overlay = input.closest('[data-jj-overlay="mobile-menu"]');
    if (!menu) return;

    function sync() {
      menu.classList.toggle('is-searching', input.value.trim() !== '');
    }

    input.addEventListener('input', sync);
    input.addEventListener('search', sync); /* the type=search clear button */

    if (!overlay) return;
    new MutationObserver(function () {
      if (overlay.getAttribute('aria-hidden') !== 'true') return;
      input.value = '';
      menu.classList.remove('is-searching');
    }).observe(overlay, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindInPlaceSearch);
  } else {
    bindInPlaceSearch();
  }
})();
